const getErrorMessageText = (error: unknown) => {
  if (error instanceof Error) return error.message
  if (typeof error === 'object' && error && 'message' in error) {
    return String((error as { message?: unknown }).message || '')
  }
  return ''
}

const getErrorCode = (error: unknown) => {
  if (typeof error === 'object' && error) {
    if ('code' in error && typeof (error as { code?: unknown }).code === 'string') {
      return String((error as { code?: string }).code)
    }
    if ('name' in error && typeof (error as { name?: unknown }).name === 'string') {
      return String((error as { name?: string }).name)
    }
  }
  return ''
}

export const isAuthFailure = (error: unknown) => {
  const signal = `${getErrorCode(error)} ${getErrorMessageText(error)}`.toLowerCase()
  return [
    'not_authenticated',
    'refresh token not found',
    'invalid_grant',
    'unauthorized',
    'login_required',
    'interaction_required',
    'consent_required',
    'token_expired',
  ].some((keyword) => signal.includes(keyword))
}

export const isNetworkFailure = (error: unknown) => {
  const signal = `${getErrorCode(error)} ${getErrorMessageText(error)}`.toLowerCase()
  return (
    (typeof navigator !== 'undefined' && navigator.onLine === false) ||
    ['network', 'fetch', 'load failed', 'timeout', 'offline', 'failed to fetch'].some((keyword) =>
      signal.includes(keyword),
    )
  )
}
